import { render, staticRenderFns } from "./AdminSchoolDetail.vue?vue&type=template&id=23df9f96&scoped=true&"
import script from "./AdminSchoolDetail.vue?vue&type=script&lang=js&"
export * from "./AdminSchoolDetail.vue?vue&type=script&lang=js&"
import style0 from "./AdminSchoolDetail.vue?vue&type=style&index=0&id=23df9f96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23df9f96",
  null
  
)

export default component.exports